import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const sendMessageChatRoom = createAsyncThunk(
    "sendMessageChatRoom",
    async ({ groupId, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/group/groups/${groupId}/chat/`, data);
            return response.data;
        } catch (error) {
            console.error("Error:", error.response?.data);
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getChatRoomList = createAsyncThunk(
    "getChatRoomList",
    async ({ groupId }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/group/groups/${groupId}/chat/`);
            return response.data;
        } catch (error) {
            console.error("Error:", error.response?.data);
            return rejectWithValue(error.response?.data);
        }
    }
);


export const GroupChatRoom = createSlice({
    name: "GroupChatRoom",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(getChatRoomList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getChatRoomList.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        });
        builder.addCase(getChatRoomList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default GroupChatRoom.reducer;
